/*
 * AEVIA — MY AEVIA: richiesta professionale (assets/aevia-my-aevia.js)
 * ---------------------------------------------------------------------
 * Caricato solo da sections/main-my-aevia.liquid. Tre funzioni:
 *
 * 1. Aggiornamento dello stato. Rilegge la STESSA sezione con la Section
 *    Rendering API di Shopify (?section_id=…), con la sessione del cliente:
 *    nessun endpoint nuovo e nessun dato oltre a quelli già nella pagina.
 *    Si guarda solo l'attributo data-mya-sig reso dal Liquid (stato reale
 *    dei metafield + contesto B2B). Mai un timer che "conclude" la
 *    verifica. v5 (2026-10-14): quando lo stato cambia la sezione viene
 *    sostituita in pagina (niente ricaricamento), intervalli progressivi,
 *    un solo controllo attivo, timeout di rete, pausa con scheda nascosta,
 *    stop dopo errori consecutivi.
 *
 * 2. Conferma dopo l'invio del modulo Shopify Forms. Mostrata solo se,
 *    dopo un invio, il modulo scompare (Forms lo sostituisce con il
 *    messaggio di conferma). Il segnale "inviato" resta in sessionStorage
 *    per 15 minuti (solo un orario, nessun dato personale) così, dopo
 *    l'accesso, il cliente non rivede il modulo prima che il Flow abbia
 *    registrato lo stato.
 *
 * 3. Campo provincia del modulo Shopify Forms (v2, 2026-10-13: solo il
 *    campo la cui etichetta è "provincia"; stili solo colori/caratteri):
 *    maiuscolo automatico, solo
 *    due lettere, messaggi AEVIA. Shopify Forms non offre un'API per
 *    farlo: il modulo vive in uno shadow DOM. Se lo shadow root non è
 *    raggiungibile o il campo non si trova, lo script non fa nulla e il
 *    modulo funziona come prima. Il controllo definitivo (formato e
 *    provincia ammessa) resta nel Flow.
 *
 * Nessun token, nessuna chiamata esterna, nessun dato fiscale letto o
 * salvato dallo script.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-mya-root]');
  if (!root) return;

  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
  var FLAG_KEY = 'aevia_mya_richiesta_inviata';
  var FLAG_TTL = 15 * 60 * 1000;
  var POLL_MAX_ERRORS = 3;
  /*
   * v5 (2026-10-14) intervalli progressivi, mai richieste infinite:
   *  auto = 20 controlli ogni 6 s, 20 ogni 30 s, 15 ogni 2 min (~42 min)
   *  slow = 30 controlli ogni 60 s (~30 min)
   * Poi solo il pulsante "Aggiorna lo stato". Pausa a scheda nascosta.
   */
  var SCHEDULES = {
    auto: [[20, 6000], [20, 30000], [15, 120000]],
    slow: [[30, 60000]]
  };

  var stateEl = root.querySelector('[data-mya-state]');
  var currentState = stateEl ? stateEl.getAttribute('data-mya-state') || '' : '';
  var currentStato = stateEl ? stateEl.getAttribute('data-mya-stato') || '' : '';
  var currentSig = sigOf(stateEl);
  var signedIn = currentState !== '' && currentState !== 'guest';
  var sectionId = root.getAttribute('data-mya-section-id') || '';

  function sigOf(el) {
    if (!el) return '';
    return el.getAttribute('data-mya-sig') ||
      ((el.getAttribute('data-mya-state') || '') + '|' + (el.getAttribute('data-mya-stato') || ''));
  }

  /* ---------- segnale "richiesta inviata" (sessionStorage) ---------- */

  function readFlag() {
    try {
      var t = parseInt(window.sessionStorage.getItem(FLAG_KEY) || '', 10);
      if (!t) return 0;
      if (Date.now() - t > FLAG_TTL) { window.sessionStorage.removeItem(FLAG_KEY); return 0; }
      return t;
    } catch (e) { return 0; }
  }
  function writeFlag() { try { window.sessionStorage.setItem(FLAG_KEY, String(Date.now())); } catch (e) {} }
  function clearFlag() { try { window.sessionStorage.removeItem(FLAG_KEY); } catch (e) {} }

  // Uno stato reale è registrato: il segnale locale non serve più.
  if (currentState !== 'none' && currentState !== 'guest') clearFlag();

  function timeLabel() {
    var d = new Date();
    return ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
  }

  /* ---------- annuncio per screen reader (una sola regione) ---------- */

  var announcer = null;
  function announce(msg) {
    if (!announcer) {
      announcer = document.createElement('p');
      announcer.className = 'aevia-visually-hidden';
      announcer.setAttribute('role', 'status');
      announcer.setAttribute('aria-live', 'polite');
      document.body.appendChild(announcer);
    }
    announcer.textContent = '';
    window.setTimeout(function () { announcer.textContent = msg; }, 60);
  }

  /* ---------- 1. aggiornamento dello stato ---------- */

  var fetchController = null;

  function fetchSection() {
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);
    var opts = { credentials: 'same-origin', cache: 'no-store' };
    var timeout = null;
    if (window.AbortController) {
      if (fetchController) { try { fetchController.abort(); } catch (e) {} }
      fetchController = new window.AbortController();
      opts.signal = fetchController.signal;
      var ctl = fetchController;
      timeout = window.setTimeout(function () { try { ctl.abort(); } catch (e) {} }, 15000);
    }
    return window.fetch(url, opts)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (timeout) window.clearTimeout(timeout);
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newRoot = doc.querySelector('[data-mya-root]');
        var el = newRoot ? newRoot.querySelector('[data-mya-state]') : null;
        if (!el) throw new Error('stato non presente');
        return {
          root: newRoot,
          state: el.getAttribute('data-mya-state') || '',
          stato: el.getAttribute('data-mya-stato') || '',
          sig: sigOf(el)
        };
      }, function (err) {
        if (timeout) window.clearTimeout(timeout);
        throw err;
      });
  }

  function reloadToAccess() {
    try { window.history.replaceState(null, '', window.location.pathname + window.location.search + '#MyAeviaAccesso'); } catch (e) {}
    window.location.reload();
  }

  /*
   * Sostituisce la sezione con quella appena resa da Shopify (stessi dati
   * Liquid, stessa sessione): nessuno stato dedotto in JavaScript. Il
   * blocco Preferiti già caricato viene conservato. Se serve il modulo di
   * richiesta (stato "none") si ricarica la pagina: il modulo dell'app
   * Shopify Forms ha bisogno dei propri script.
   */
  function applyUpdate(s) {
    if (s.state === 'none' || s.state === 'guest' || !s.root) { reloadToAccess(); return; }
    var fresh = document.importNode(s.root, true);
    var oldFav = root.querySelector('#MyAeviaPreferiti');
    var newFav = fresh.querySelector('#MyAeviaPreferiti');
    if (oldFav && newFav) newFav.parentNode.replaceChild(oldFav, newFav);
    var hadFocus = root.contains(document.activeElement) && document.activeElement !== document.body;

    stopWatch();
    root.parentNode.replaceChild(fresh, root);
    root = fresh;
    stateEl = root.querySelector('[data-mya-state]');
    currentState = s.state;
    currentStato = s.stato;
    currentSig = s.sig;
    clearFlag();

    var titleEl = stateEl && (stateEl.querySelector('.aevia-my-aevia__wait-title') || stateEl.querySelector('.aevia-my-aevia__status'));
    announce('Stato della richiesta aggiornato' + (titleEl ? ': ' + titleEl.textContent.trim() : '.'));
    if (hadFocus && stateEl) { try { stateEl.focus({ preventScroll: false }); } catch (e) { stateEl.focus(); } }

    try { document.dispatchEvent(new CustomEvent('aevia:mya-updated')); } catch (e) {}
    initStateWatch();
  }

  var activeWatch = null;
  function stopWatch() {
    if (activeWatch) { activeWatch.stop(); activeWatch = null; }
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && activeWatch) activeWatch.resume();
  });

  /*
   * Collega a un pannello (con [data-mya-live]) l'aggiornamento:
   * mode 'auto' | 'slow' = controlli periodici + pulsante, 'manual' =
   * solo pulsante. Un solo controllo attivo per pagina (activeWatch).
   */
  function startStatusWatch(panel, mode) {
    if (!panel || !sectionId || DESIGN_MODE || !window.fetch || !window.DOMParser) return;
    var live = panel.querySelector('[data-mya-live]');
    var text = panel.querySelector('[data-mya-live-text]');
    var button = panel.querySelector('[data-mya-refresh]');
    if (!live || !text || !button) return;
    stopWatch();
    live.hidden = false;

    var plan = SCHEDULES[mode] || null;
    var attempts = 0;
    var errors = 0;
    var timer = null;
    var busy = false;
    var stopped = false;
    var auto = !!plan;
    var lastCheck = Date.now();

    function say(msg) { text.textContent = msg; }

    function delay() {
      var n = attempts;
      for (var i = 0; i < plan.length; i++) {
        if (n < plan[i][0]) return plan[i][1];
        n -= plan[i][0];
      }
      return 0; // piano esaurito
    }

    function check(manual) {
      if (busy || stopped) return;
      busy = true;
      // aria-disabled (non disabled): il pulsante non perde il focus.
      button.setAttribute('aria-disabled', 'true');
      lastCheck = Date.now();
      fetchSection().then(function (s) {
        if (stopped) return;
        errors = 0;
        if (s.sig !== currentSig) {
          say('Stato aggiornato.');
          busy = false;
          applyUpdate(s);
          return;
        }
        say((manual ? 'Nessuna variazione' : 'Aggiornamento automatico attivo') + ' · ultimo controllo alle ' + timeLabel());
      }).catch(function () {
        if (stopped) return;
        errors += 1;
        if (errors >= POLL_MAX_ERRORS) { auto = false; }
        say(errors >= POLL_MAX_ERRORS
          ? 'Impossibile aggiornare lo stato in questo momento. Usa “Aggiorna lo stato” tra poco.'
          : 'Impossibile aggiornare lo stato in questo momento. Nuovo tentativo a breve.');
      }).then(function () {
        if (stopped) return;
        busy = false;
        button.removeAttribute('aria-disabled');
        schedule();
      });
    }

    function schedule() {
      if (timer) { window.clearTimeout(timer); timer = null; }
      if (!auto || stopped) return;
      var d = delay();
      if (!d) {
        auto = false;
        say('Aggiornamento automatico sospeso. Usa “Aggiorna lo stato” per un nuovo controllo.');
        return;
      }
      if (document.hidden) return; // ripreso da visibilitychange
      timer = window.setTimeout(function () { timer = null; attempts += 1; check(false); }, d);
    }

    function onClick() { check(true); }
    button.addEventListener('click', onClick);

    activeWatch = {
      stop: function () {
        stopped = true;
        if (timer) { window.clearTimeout(timer); timer = null; }
        button.removeEventListener('click', onClick);
      },
      resume: function () {
        if (stopped || busy || !auto) return;
        // Tornando sulla scheda dopo una lunga pausa, controllo subito.
        if (!timer && Date.now() - lastCheck >= (delay() || 0)) { attempts += 1; check(false); return; }
        if (!timer) schedule();
      }
    };

    say(auto ? 'Aggiornamento automatico attivo.' : 'Per verificare eventuali novità usa “Aggiorna lo stato”.');
    schedule();
  }

  function initStateWatch() {
    if (!stateEl || !signedIn) return;
    var poll = stateEl.getAttribute('data-mya-poll');
    if (poll === 'auto' || poll === 'slow' || poll === 'manual') startStatusWatch(stateEl, poll);
  }
  initStateWatch();

  /* ---------- 2 + 3. modulo di richiesta ---------- */

  var request = root.querySelector('[data-mya-request]');
  if (!request) return;

  var requestBody = request.querySelector('[data-mya-request-body]');
  var sentSlot = request.querySelector('[data-mya-sent-slot]');
  var sentTemplate = request.querySelector('[data-mya-sent-template]');
  var formWrap = request.querySelector('[data-mya-form]');
  var allowed = (request.getAttribute('data-mya-provincia-allowed') || '').split(/\s+/).filter(Boolean);
  var sentShown = false;

  function showSent(restored) {
    if (sentShown || !sentSlot || !sentTemplate || !requestBody) return;
    sentShown = true;
    sentSlot.innerHTML = '';
    sentSlot.appendChild(sentTemplate.content.cloneNode(true));
    requestBody.hidden = true;
    sentSlot.hidden = false;
    // Il riquadro "Nessuna richiesta inviata" sopra contraddirebbe la conferma.
    if (stateEl && currentState === 'none') stateEl.hidden = true;

    var panel = sentSlot.querySelector('[data-mya-sent]');
    var showForm = sentSlot.querySelector('[data-mya-show-form]');
    if (restored && showForm) {
      showForm.hidden = false;
      showForm.addEventListener('click', function () {
        clearFlag();
        sentSlot.hidden = true;
        sentSlot.innerHTML = '';
        requestBody.hidden = false;
        if (stateEl) stateEl.hidden = false;
        sentShown = false;
      });
    }
    if (panel) {
      if (!restored) { try { panel.focus({ preventScroll: false }); } catch (e) { panel.focus(); } }
      if (signedIn) startStatusWatch(panel, 'auto');
    }
  }

  if (!DESIGN_MODE && (currentState === 'none' || currentState === 'guest') && readFlag()) {
    showSent(true);
  }

  if (!formWrap || DESIGN_MODE) return;

  /* -- shadow root del modulo -- */

  /*
   * v2 (2026-10-13): SOLO colori e caratteri. Nessuna proprietà di
   * impaginazione (padding, altezza, dimensione del testo, interlinea,
   * posizione, trasformazioni): la v1 le forzava e rompeva le etichette
   * "flottanti" di Shopify Forms (etichetta sovrapposta al valore). Senza
   * il markup reale del modulo non si cambia la geometria dei campi.
   */
  var FORM_CSS = [
    'input, select, textarea, label, button { font-family: var(--aevia-font-body) !important; }',
    // v3: nessuno sfondo forzato sui campi. Le etichette di Forms hanno un
    // proprio sfondo (bianco) per "tagliare" il bordo: con il campo crema
    // diventava una striscia bianca sopra il testo. Lo sfondo dei campi si
    // imposta da Shopify Forms > Stile, così etichetta e campo coincidono.
    'input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), select, textarea {',
    '  color: var(--aevia-color-text) !important; border-color: var(--aevia-color-border-on-sabbia) !important; }',
    'input:focus-visible, select:focus-visible, textarea:focus-visible, button:focus-visible { outline: 2px solid var(--aevia-color-primary) !important; outline-offset: 2px; }',
    'input[aria-invalid="true"] { border-color: var(--aevia-color-primary) !important; }',
    'button[type="submit"] { background-color: var(--aevia-color-primary) !important; border-color: var(--aevia-color-primary) !important;',
    '  color: var(--aevia-color-text-inverse) !important; }',
    'button[type="submit"]:hover, button[type="submit"]:focus-visible { filter: brightness(0.9); }',
    '.aevia-forms-hint { margin: var(--aevia-space-1) 0 0; font-size: var(--aevia-caption-size); line-height: var(--aevia-line-height-body);',
    '  color: var(--aevia-color-primary); padding-left: var(--aevia-space-1); border-left: 2px solid var(--aevia-color-primary); }',
    '.aevia-forms-hint[hidden] { display: none; }',
    '.aevia-forms-hint--info { color: var(--aevia-color-text); border-left-color: var(--aevia-color-accent); }'
  ].join('\n');

  function injectStyles(sr) {
    try {
      if ('adoptedStyleSheets' in sr && typeof CSSStyleSheet === 'function' && CSSStyleSheet.prototype.replaceSync) {
        var sheet = new CSSStyleSheet();
        sheet.replaceSync(FORM_CSS);
        sr.adoptedStyleSheets = sr.adoptedStyleSheets.concat([sheet]);
        return;
      }
    } catch (e) { /* fallback sotto */ }
    var style = document.createElement('style');
    style.textContent = FORM_CSS;
    sr.appendChild(style);
  }

  /* -- campo provincia -- */

  var valueSetter = (Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value') || {}).set;

  /*
   * v2: solo l'etichetta PROPRIA del campo (label[for] o aria-label).
   * Niente segnaposto, niente nome tecnico, niente label contenitore:
   * nella v1 un indizio debole poteva far scambiare il campo indirizzo
   * per la provincia (maiuscolo forzato e massimo 2 caratteri).
   */
  function ownLabel(input, sr) {
    var text = '';
    if (input.id) {
      var esc = window.CSS && window.CSS.escape ? window.CSS.escape(input.id) : input.id;
      var forLabel = sr.querySelector('label[for="' + esc + '"]');
      if (forLabel) text = forLabel.textContent;
    }
    if (!text) text = input.getAttribute('aria-label') || '';
    return text.replace(/\s+/g, ' ').trim();
  }

  var NOT_PROVINCIA = /indirizzo|\bvia\b|civico|comune|citt|\bcap\b|partita|iva|email|nome|ragione/i;

  // Un solo campo di testo la cui etichetta nomina la provincia e nient'altro
  // di riconoscibile. Zero o più candidati: nessun intervento.
  function findProvincia(sr) {
    var found = [];
    var inputs = sr.querySelectorAll('input');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var type = (input.getAttribute('type') || 'text').toLowerCase();
      if (type !== 'text') continue;
      var label = ownLabel(input, sr);
      if (!/provincia/i.test(label) || NOT_PROVINCIA.test(label)) continue;
      found.push(input);
    }
    return found.length === 1 ? found[0] : null;
  }

  function checkProvincia(raw) {
    var v = String(raw || '').trim().toUpperCase();
    if (!v) return { code: 'empty', value: v };
    if (!/^[A-Z]{2}$/.test(v)) return { code: 'format', value: v };
    if (allowed.length && allowed.indexOf(v) === -1) return { code: 'excluded', value: v };
    return { code: 'ok', value: v };
  }

  var MSG_FORMAT = 'Inserisci la sigla della provincia della sede legale: due lettere, ad esempio PZ.';
  function msgExcluded(v) {
    return 'La provincia ' + v + ' non rientra nel territorio servito (' + allowed.join(', ') +
      '): con questa sede legale la richiesta non potrà essere approvata.';
  }

  function bindProvincia(input, sr) {
    if (input.getAttribute('data-aevia-provincia') === '1') return;
    input.setAttribute('data-aevia-provincia', '1');
    input.setAttribute('maxlength', '2');
    input.setAttribute('autocapitalize', 'characters');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('spellcheck', 'false');

    var hint = document.createElement('p');
    hint.className = 'aevia-forms-hint';
    hint.id = 'aevia-provincia-hint';
    hint.hidden = true;
    hint.setAttribute('aria-live', 'polite');
    if (input.parentNode) input.parentNode.appendChild(hint);
    var described = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (described.indexOf(hint.id) === -1) described.push(hint.id);
    input.setAttribute('aria-describedby', described.join(' '));

    function render(result, strict) {
      // strict: dopo l'uscita dal campo o all'invio; durante la digitazione
      // si segnalano subito solo caratteri non validi.
      var showFormat = result.code === 'format' && (strict || /[^A-Z]/.test(result.value));
      if (showFormat) {
        hint.textContent = MSG_FORMAT;
        hint.className = 'aevia-forms-hint';
        hint.hidden = false;
        input.setAttribute('aria-invalid', 'true');
      } else if (result.code === 'excluded') {
        hint.textContent = msgExcluded(result.value);
        hint.className = 'aevia-forms-hint aevia-forms-hint--info';
        hint.hidden = false;
        input.removeAttribute('aria-invalid');
      } else {
        hint.hidden = true;
        hint.textContent = '';
        input.removeAttribute('aria-invalid');
      }
    }

    input.addEventListener('input', function (e) {
      if (e.isComposing) return;
      var v = input.value;
      var up = v.toUpperCase();
      if (up !== v && valueSetter) {
        var s = input.selectionStart;
        var en = input.selectionEnd;
        // Setter nativo + evento input: il modulo (React) registra il
        // valore maiuscolo nel proprio stato, quindi viene inviato così.
        valueSetter.call(input, up);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        try { input.setSelectionRange(s, en); } catch (err) {}
      }
      render(checkProvincia(input.value), false);
    });
    input.addEventListener('blur', function () {
      if (input.value) render(checkProvincia(input.value), true);
    });

    input.__aeviaRender = render;
    // Valore già presente (es. compilazione automatica del browser).
    if (input.value) render(checkProvincia(input.value), false);
  }

  /* -- invio: blocco solo per formato provincia errato, poi conferma -- */

  function attach(sr) {
    if (sr.__aeviaMya) return;
    sr.__aeviaMya = true;
    injectStyles(sr);

    var submittedAt = 0;

    function provinciaBlocks() {
      var input = findProvincia(sr);
      if (!input) return false;
      var result = checkProvincia(input.value);
      if (result.code !== 'format') return false; // vuoto: lo gestisce Forms (obbligatorio)
      if (input.__aeviaRender) input.__aeviaRender(result, true);
      try { input.focus(); } catch (e) {}
      return true;
    }

    function guard(e) {
      if (provinciaBlocks()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      submittedAt = Date.now();
      watchSuccess();
    }

    sr.addEventListener('submit', guard, true);
    sr.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button[type="submit"], input[type="submit"]') : null;
      if (btn) guard(e);
    }, true);

    function hasFields() {
      return !!sr.querySelector('input:not([type="hidden"]), select, textarea');
    }

    var successTimers = [];
    function watchSuccess() {
      successTimers.forEach(window.clearTimeout);
      successTimers = [1000, 3000, 6000, 10000, 20000].map(function (ms) {
        return window.setTimeout(checkSuccess, ms);
      });
    }
    function checkSuccess() {
      if (!submittedAt || Date.now() - submittedAt > 30000) return;
      if (!hasFields()) {
        submittedAt = 0;
        writeFlag();
        showSent(false);
      }
    }

    var mo = new MutationObserver(function () {
      var input = findProvincia(sr);
      if (input) bindProvincia(input, sr);
      if (submittedAt) checkSuccess();
    });
    mo.observe(sr, { childList: true, subtree: true });

    var first = findProvincia(sr);
    if (first) bindProvincia(first, sr);
  }

  function scan() {
    var all = formWrap.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var sr = all[i].shadowRoot;
      if (sr) attach(sr);
    }
  }

  new MutationObserver(scan).observe(formWrap, { childList: true, subtree: true });
  scan();
})();
